import { unixtime } from '~/assistant/utils/number';

export function setCookie(name: string, value: string, exp: any) {
  let maxAge = exp - unixtime(new Date());
  document.cookie = `${name}=${value}; max-age=${maxAge}; path=/;`;
}

export function getCookie(name: string) {
  let value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return value ? value[2] : null;
}
